import { ROUTES } from '@constants/ROUTES';

import { PLAN_CARD } from '@interfaces/nonLearnerHomePage';

import CommonAppIcon from '@images/common-app-logo.svg?react';
import ChecklistIcon from '@images/checklist.svg?react';

export const CARD_IDS = {
  MAJORS: 101,
  SCHOOLS: 102,
  EDUCATION_PLANNER: 103,
  SCHOLARSHIPS: 104,
  RECOMMENDER_SPACE: 105,
  EDUCATION_PLANNER_APPLICATIONS: 106,
  EDUCATION_PLANNER_APPLICATIONS_COMMON_APP: 107,
};

export const PLAN_FOR_COLLEGE_CARDS: PLAN_CARD[] = [
  {
    id: CARD_IDS.EDUCATION_PLANNER_APPLICATIONS,
    icon: <ChecklistIcon />,
    title: 'Apply to college',
    navigationUrl: ROUTES.EDUCATION_PLANNER_APPLICATIONS,
  },
  {
    id: CARD_IDS.EDUCATION_PLANNER_APPLICATIONS_COMMON_APP,
    icon: <CommonAppIcon />,
    title: 'Apply to college with Common App',
    navigationUrl: ROUTES.EDUCATION_PLANNER_APPLICATIONS,
  },
  {
    id: CARD_IDS.EDUCATION_PLANNER,
    icon: <ChecklistIcon />,
    title: 'College planning',
    navigationUrl: ROUTES.EDUCATION_PLANNER,
  },
];
